<template>
    <div class="error-outer">
        Error loading data. Please try again later.
    </div>
</template>

<style scoped>
.error-outer {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 0.05fr 1fr 0.05fr;
    height: 100%;
    gap: 10px;
    padding-inline: 3%;
    font-size: var(--font-size-body);
}
</style>
